import { defaultCompanyCodeUs, netjetsCompaniesArr } from "domain/company/constants";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useAuth } from "../auth/useAuth";

const defaultCompanyCodes = [defaultCompanyCodeUs];
const emptyArr = [];

export const useCompany = () => {
  const { user, isUserInGroup } = useAuth();

  const userCompanyCodes = useMemo(() => {
    return netjetsCompaniesArr
      .filter(
        (c) =>
          c.businessUnitId === user?.businessUnitID || // matches business unit id
          c.domain === user?.domain || // matches domain
          (!!c.emailDomain && user?.email?.endsWith(c.emailDomain)) || // matches email
          c.oktaGroups.some(isUserInGroup), // matches okta group
      )
      .map((c) => c.companyCode);
  }, [isUserInGroup, user?.businessUnitID, user?.domain, user?.email]);

  const [selectedCompanyCode, setSelectedCompanyCode] = useState<string>(undefined);

  const isUserValue = !!userCompanyCodes.length;
  const companyCodes = isUserValue ? userCompanyCodes : !!user ? defaultCompanyCodes : emptyArr;
  const firstCompanyCode = companyCodes[0];

  const selectCompany = useCallback(
    (companyCode: string) => {
      if (!!companyCode && !companyCodes.includes(companyCode)) {
        setSelectedCompanyCode(undefined);
      }
      setSelectedCompanyCode(companyCode);
    },
    [companyCodes],
  );

  useEffect(() => {
    if (companyCodes.length === 1 && selectedCompanyCode !== firstCompanyCode) {
      setSelectedCompanyCode(firstCompanyCode);
    } else if (!!selectedCompanyCode && !companyCodes.includes(selectedCompanyCode)) {
      setSelectedCompanyCode(firstCompanyCode);
    }
  }, [firstCompanyCode, selectedCompanyCode, companyCodes, userCompanyCodes.length]);

  return {
    isUserValue,
    companyCodes,
    selectedCompanyCode,
    selectCompany,
  };
};
